import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar'

import blogs from '../../api/blogs'

// Dynamically import all images from images/gallery
const importAll = (r) => r.keys().map(r);
const galleryImages = importAll(require.context('../../images/gallery', false, /\.(png|jpe?g|svg)$/));

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogList = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const openModal = (idx) => {
        setCurrentIndex(idx);
        setModalOpen(true);
    };
    const closeModal = () => setModalOpen(false);
    const prevImage = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
    };
    const nextImage = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
    };

    return (
        <section className={`blog-pg-section section-padding ${props.blnewclass}`}>
            {/* <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            {blogs.slice(0, 3).map((blog, bitem) => (
                                <div className={`post  ${blog.blClass}`} key={bitem}>
                                    <div className="entry-media">
                                        <img src={blog.blogSingleImg} alt='' />
                                        <span>{blog.day}<br />
                                            Feb</span>
                                    </div>
                                    <div className="entry-meta">
                                        <ul>
                                            <li><i className="fi flaticon-user"></i> By <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.author}</Link> </li>
                                            <li><i className="fi ti-comment-alt"></i> Comments {blog.comment} </li>
                                            <li><i className="fi flaticon-clock"></i><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>3 min Read</Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="entry-details">
                                        <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title2}</Link></h3>
                                        <p>There are many variations of passages of Lorem Ipsum available, but majority have
                                            suffered
                                            teration in some form, by injected humour, or randomised words which don't look
                                            even slight
                                            believable. If you are going to use a passage of Lorem Ipsum.</p>
                                        <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`} className="read-more">READ MORE...</Link>
                                    </div>
                                </div>
                            ))}


                            <div className="pagination-wrapper pagination-wrapper-left">
                                <ul className="pg-pagination">
                                    <li>
                                        <Link to="/blog-left-sidebar" aria-label="Previous">
                                            <i className="fi ti-angle-left"></i>
                                        </Link>
                                    </li>
                                    <li className="active"><Link to="/blog-left-sidebar">1</Link></li>
                                    <li><Link to="/blog-left-sidebar">2</Link></li>
                                    <li><Link to="/blog-left-sidebar">3</Link></li>
                                    <li>
                                        <Link to="/blog-left-sidebar" aria-label="Next">
                                            <i className="fi ti-angle-right"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div> */}
            <div className='container'>
                <div className="row">
                    <div className="col col-lg-12 col-12">
                        <div className="gallery-content" style={{ display: 'flex', flexWrap: 'wrap', gap: '64px' }}>
                            {galleryImages.map((img, idx) => (
                                <div key={idx} style={{ flex: '0 1 30%', marginBottom: '20px' }}>
                                    <img
                                        src={img}
                                        alt={`gallery-${idx}`}
                                        style={{
                                            width: '500px',
                                            height: '300px',
                                            objectFit: 'cover',
                                            borderRadius: '10px',
                                            display: 'block',
                                            margin: '0 auto',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => openModal(idx)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* Modal for image gallery */}
                {modalOpen && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0,0,0,0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }} onClick={closeModal}>
                        <button onClick={prevImage} style={{ position: 'absolute', left: 30, top: '50%', fontSize: 30, color: '#fff', background: 'none', border: 'none', cursor: 'pointer' }}>&lt;</button>
                        <img src={galleryImages[currentIndex]} alt="" style={{ maxHeight: '80vh', maxWidth: '80vw', borderRadius: 8, boxShadow: '0 2px 20px #000' }} onClick={e => e.stopPropagation()} />
                        <button onClick={nextImage} style={{ position: 'absolute', right: 30, top: '50%', fontSize: 30, color: '#fff', background: 'none', border: 'none', cursor: 'pointer' }}>&gt;</button>
                        <button onClick={closeModal} style={{ position: 'absolute', top: 30, right: 30, fontSize: 30, color: '#fff', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
                    </div>
                )}
            </div>
        </section>
    )

}

export default BlogList;
